import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { DeveloperToolsTabs } from '@pages/DeveloperTools/DeveloperToolsContext';
import { PermissionsType } from '@shared/types/forms';
import { caseAgnosticPages, getPage } from './utils';

export const useAppLocation = () => {
  const location = useLocation();
  const urlPathname = location.pathname.split('/').slice(1);
  const page = getPage(location.pathname, urlPathname[0]);
  const isOrganizationPathname = useMemo(
    () => urlPathname.includes(PermissionsType.Organization),
    [urlPathname],
  );
  const isApiKeysPathname = useMemo(
    () => urlPathname.includes(DeveloperToolsTabs.API_KEYS),
    [urlPathname],
  );
  const shouldShowOrgOrCase = !caseAgnosticPages.includes(page);

  return {
    location,
    urlPathname,
    page,
    isOrganizationPathname,
    isApiKeysPathname,
    shouldShowOrgOrCase,
  };
};

export default useAppLocation;
